import { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './sidebar';
import Header from './topbar';
import { LayoutProvider } from '../../contexts/LayoutContext';
import ChildLayout from './child';

import { useDispatch } from 'react-redux';
import { useAuth } from '../../contexts/AuthContext';
import NormalChildLayout from './child/normal';
import { dropdownService } from '../../api/dropdown';
import { setAllMeasurements } from '../../store/reducers/dropdown';
import ScrollToTop from '../ScrollToTop';

const Layout = memo(({ normal = false, ...props }) => {
    const { logout } = useAuth()
    const dispatch = useDispatch()
    const lastCalledRef = useRef(0);

    useEffect(() => {
        const now = new Date().getTime();
        if (now - lastCalledRef.current > 5000) {
            lastCalledRef.current = now;
            (async () => {
                try {
                    // Measurements
                    const response_measurements = await dropdownService.getAllMeasurements();
                    if (response_measurements) {
                        dispatch(setAllMeasurements(response_measurements?.data?.filter(i => i?.show_in_documents == 1)?.map((item, index) => ({ ...item, title: item?.measures_title, measures_title: `${item?.measures_number} - ${item?.measures_title}` }))))
                    }
                } catch (error) {
                    if (error?.response?.status === 401) { logout?.() }
                }
            })();
        }
    }, [global.auth_token]);

    return (
        <ScrollToTop >
            <LayoutProvider>
                {!normal && (
                    <>
                        <Header key="header" />
                        <Sidebar key="sidebar" />
                        <ChildLayout key="child" {...props} />
                    </>
                )}
                {normal && (<NormalChildLayout key="child" {...props} />)}
            </LayoutProvider>
        </ScrollToTop>
    );
});

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;